import React, { useState, useRef, useEffect, useMemo, FC } from "react"
import Styles from "../styles/Video.module.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import MediaQuery from "react-responsive";
import {
    faSyncAlt, faPlay,
    faPause, faStepForward, faEject, faStepBackward,
    faExpand, faExchangeAlt, faVolumeUp, faVolumeMute,
    faEllipsisV, faSearchPlus, faSearchMinus
} from '@fortawesome/free-solid-svg-icons'
import { faPlayCircle } from '@fortawesome/free-regular-svg-icons'
import ActionSheet from "../components/ActionSheet";
import VideoDrawModal from "../templates/VideoDrawModal";
import useMoveObjectAndPinchToZoom from "../hooks/useMoveObjectAndPinchToZoom"
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'hls.... Remove this comment to see the full error message
import Hls from "hls.js";
import axios from "axios"
import { changeMillisec2Minute } from "../utils/utilFunctions"
import { ActionSheetMenuType } from "../types/models/ActionSheetMenu";
import { ActionObjectType, VideoSelectAction, VideoSelectActionType, WebViewVideoAction, WebViewVideoActionType } from "../types/WebViewVideoAction"
import { VideoType, WebViewVideoType } from "../types/models/Media/Video";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { LocalVideoAction } from "../types/LocalVideoAction";
import { useVideoViewIncrement } from "../hooks/useVideoViewIncrement";
import { useGetVideoViewCount } from "../hooks/useGetVideoViewCount";
import clsx from "clsx"
import { BsGrid3X3, BsPencil } from "react-icons/bs";
import { useGridLineWithStage } from "../hooks/useGridLineWithStage";

// import videojs from 'video.js'
// import "video.js/dist/video-js.css"
// import getNewPathAvoidingCache from "../functions/getNewPathAvoidingCache";
// import useGetVideoPathAvoidingCache from "../functions/useGetVideoPathAvoidingCache"


const ENVIRONMENT = process.env.ENVIRONMENT
const rangeMax = 10000

const gridXNumList = [ 0, 11, 5, 3 ] as const
const gridYNumList = [ 0, 11, 5, 3 ] as const

type Props = {
    originalFile: string,
    thumbnail?: string,
    sync: boolean,
    setSync?: ( sync: boolean ) => void,
    index: number,
    transparent?: boolean,
    action: ActionObjectType | null,
    dispatch: ( actionObject: ActionObjectType ) => void,
    forWebView?: boolean,
    handleVideoSelectSwitch?: ( action: VideoSelectActionType, video: VideoType | WebViewVideoType ) => void,
    videoIsSelected?: boolean,
    webViewDispatch?: ( action: WebViewVideoActionType ) => void,
    forComparison: boolean,
    isLocalFile?: boolean,
    backgroundTransparent?: boolean,
    showVideo?: () => void,
    showThumbnailInitially?: boolean,
    videoLoadAndAutoPlay?: boolean
}

const Video: FC<Props> = ( {
    originalFile,
    thumbnail,
    sync,
    setSync,
    index,
    transparent,
    action,
    dispatch,
    forWebView = false,
    handleVideoSelectSwitch = () => { },
    videoIsSelected,
    webViewDispatch = ( action ) => { },
    forComparison = false,
    isLocalFile = false,
    backgroundTransparent = false,
    showVideo,
    showThumbnailInitially = false,
    videoLoadAndAutoPlay = false,
} ) => {
    // console.log( "original", originalFile )
    // file = ENVIRONMENT === "production" ? file : "https://d2ml46mqa54h0p.cloudfront.net/LDOM1383/Video_v4.m3u8"
    // file = ENVIRONMENT === "production" ? file : file
    // ( "/video.m3u8" )

    const video = useRef<HTMLVideoElement>( null )
    const videoWrapperRef = useRef<HTMLDivElement>( null )
    const rangeInput = useRef<HTMLInputElement>( null )
    const downloadVideoLinkRef = useRef<HTMLAnchorElement>( null )

    const [ file, setFile ] = useState( originalFile )
    const [ fileWithParameter, setFileWithParameter ] = useState( originalFile )
    const [ fileMp4, setFileMp4 ] = useState( "" )
    const [ videoCurrentTime, setVideoCurrentTime ] = useState( 0.3 )
    const [ videoDuration, setVideoDuration ] = useState( 0 )
    const [ play, setPlay ] = useState( false )
    const [ slow, setSlow ] = useState( false )
    const [ isFlippedHorizontal, setIsFlippedHorizontal ] = useState( false )
    const [ scale, setScale ] = useState( 1 )
    // const [ videoLoadAndAutoPlay, _ ] = useState( !showThumbnailInitially )

    const [ soundOn, setSoundOn ] = useState( false )

    const [ frameButtonTouched, setFrameButtonTouched ] = useState( false ) //touchstartとmousedownで二回発生しないように
    const [ frameButtonPressTimeUpdateInterval, setFrameButtonPressTimeUpdateInterval ] = useState<NodeJS.Timeout | null>( null )
    const [ frameButtonPressTime, setFrameButtonPressTime ] = useState( 0 )
    const [ thisVideoSyncStartTime, setThisVideoSyncStartTime ] = useState<number>( 0 )

    const [ actionSheetVisible, setActionSheetVisible ] = useState( false )
    const [ drawMode, setDrawMode ] = useState( false )

    const [ avoidingCacheCount, setAvoidingCacheCount ] = useState( 0 )


    const currentSync = useRef<boolean>( sync )

    const videoViewCount = useGetVideoViewCount( { originalFile } )
    useVideoViewIncrement( { isValidCount: !forComparison, originalFile, videoCurrentTime } )

    const { stageNum, incrementGridStage, GridLines } = useGridLineWithStage<typeof gridXNumList[ "length" ]>( {
        objectRef: videoWrapperRef,
        xNumList: gridXNumList,
        yNumList: gridYNumList,
        deps: [ videoIsSelected ]
    } )

    useEffect( () => {
        if ( !videoDuration ) return
        setVideoDuration( 0 )
        setFile( originalFile )
        setFileWithParameter( originalFile )
    }, [ originalFile ] )

    useEffect( () => {
        if ( !video ) return
        if ( !originalFile ) return
        if ( !originalFile.includes( '.m3u8' ) ) return
        videoDuration || readMetaFileAndSetDuration()

        // if( video.current.canPlayType( 'application/vnd.apple.mpegurl' ) || Hls.isSupported() ) {
        //     console.log( "2" )
        //     hls.attachMedia( video.current );
        //     hls.on( Hls.Events.MEDIA_ATTACHED, function () {
        //         hls.loadSource( file );
        //         // hls.on( Hls.Events.MANIFEST_PARSED, function ( event, data ) {
        //         // 	let fragments = data.levels[ 0 ].details.fragments
        //         // 	let play_time = 0
        //         // 	for( let i in fragments ) {
        //         // 		play_time += fragments[ i ].duration
        //         // 	}
        //         // 	play_time = Math.floor( ( play_time * 1000 ) + 1000 )
        //         // } )
        //     } )
        // }
    }, [ video ] )

    useEffect( () => {
        if ( videoDuration ) return
        // video.current && video.current.load()
        isLocalFile && setTimeout( () => setVideo(), 500 )
    }, [ fileWithParameter ] )

    useEffect( () => {
        let newFileWithParameter = file
        const avoidingCacheParameter = new Date().getTime() * avoidingCacheCount
        if ( file ) {
            const videoStartTime = file.split( "#t=" )[ 1 ]
            newFileWithParameter = videoStartTime ?
                file.split( "#t=" )[ 0 ] + "?" + avoidingCacheParameter + "#t=" + videoStartTime :
                file.split( "#t=" )[ 0 ] + "?" + avoidingCacheParameter
        }

        if ( isLocalFile ) {
            newFileWithParameter = file.split( "#t=" )[ 0 ]
            // video.current && video.current.load()
        }
        if ( !videoDuration && avoidingCacheCount ) {
            setFileWithParameter( newFileWithParameter )
        }
    }, [ avoidingCacheCount ] )

    useEffect( () => {
        !videoDuration && video.current?.load()
    }, [ fileWithParameter ] )


    const readMetaFileAndSetDuration = () => {

        const videoFile = originalFile.split( "/" ).slice( 0, -1 ).join( "/" ) + "/Video_v4.m3u8"
        const audioFile = originalFile.split( "/" ).slice( 0, -1 ).join( "/" ) + "/Audio_v4.m3u8"

        const readMetaFile = async ( file: string ) => {
            let fileExists
            await axios.get( file )
                .then( response => {
                    const allText = response.data
                    const stringTimeArray: string[] = allText.split( '#EXTINF:' )
                    const timeArray = stringTimeArray.map( time => Number( time.split( ',' )[ 0 ] ) ).filter( t => t )
                    const time = timeArray.reduce( ( a, c ) => a + c )
                    setVideoDuration( Number( time ) )
                    fileExists = true
                } )
                .catch( e => fileExists = false )
            return fileExists
        }

        const readMeta = async () => {
            const audioFileExists = await readMetaFile( audioFile )
            if ( !audioFileExists ) {
                readMetaFile( videoFile )
                setFile( videoFile )
            }
        }

        readMeta()
    }

    useEffect( () => {
        if ( showThumbnailInitially ) return
        if ( !originalFile ) return
        if ( originalFile.includes( '.mp4' ) ) {
            // if ( video.current ) video.current.src = originalFile
            playOrShowFirstFrame()
            setFileMp4( originalFile )
            return
        }

        if ( originalFile.includes( '.m3u8' ) ) {
            if ( video.current && video.current.canPlayType( 'application/vnd.apple.mpegurl' ) ||
                Hls.isSupported()
            ) {
                const hls = new Hls();
                hls.loadSource( originalFile );
                hls.attachMedia( video.current );
                hls.on( Hls.Events.MANIFEST_PARSED, () => playOrShowFirstFrame() );
            }

            const fileMp4 = file.split( '/' ).slice( 0, -1 ).join( '/' ) + '.mp4'
            setFileMp4( fileMp4 )
        }
        else {
            // if ( video.current ) video.current.src = originalFile
            playOrShowFirstFrame()
            setFileMp4( originalFile )
            return
        }
    }, [ originalFile, showThumbnailInitially ] )

    // useEffect( () => {
    //     if ( file === originalFile ) return
    //     if ( video.current?.canPlayType( 'application/vnd.apple.mpegurl' ) ) {
    //         video.current.src = fileMp4
    //         alert("file")
    //     }
    // }, [ file ] )


    useEffect( () => {
        setPlay( false )
    }, [ drawMode ] )

    useEffect( () => {
        ( action && sync ) && reduce( action )
    }, [ action ] )

    useEffect( () => {
        if ( showThumbnailInitially ) return
        play ?
            video.current && video.current.play() :
            video.current && video.current.pause()
    }, [ play ] )

    useEffect( () => {
        if ( showThumbnailInitially ) return
        if ( slow && video.current ) video.current.playbackRate = 0.5
        else if ( video.current ) video.current.playbackRate = 1
    }, [ slow ] )

    useEffect( () => {
        if ( showThumbnailInitially ) return
        currentSync.current = sync;
        video.current && setThisVideoSyncStartTime( video.current.currentTime )
    }, [ sync ] );

    const playOrShowFirstFrame = () => {
        setPlay( true )
        !videoLoadAndAutoPlay && setTimeout( () => {
            setPlay( false )
        }, 10 );
    }

    const reduce = ( action: ActionObjectType ) => {
        switch ( action.type ) {
            case LocalVideoAction.PLAY:
                setPlay( true )
                return
            case LocalVideoAction.PAUSE:
                setPlay( false )
                return
            case LocalVideoAction.SET_USUAL_SPEED:
                setSlow( false )
                return
            case LocalVideoAction.SET_SLOW:
                setSlow( true )
                return
            case LocalVideoAction.TICK:
                if ( video.current && action.time ) video.current.currentTime += action.time
                if ( video.current && video.current.currentTime <= 0 ) dispatch( { type: LocalVideoAction.SET_TIME_TO_SYNC_START_TIME } )
                return
            case LocalVideoAction.SET_TIME_TO_SYNC_START_TIME:
                if ( !video.current ) return
                video.current.currentTime = thisVideoSyncStartTime
                return
            case LocalVideoAction.SET_TIME_TO_SYNC_START_TIME_AND_PLAY:
                if ( !video.current ) return
                video.current.currentTime = thisVideoSyncStartTime
                video.current.play() //なぜか止まるので
                setPlay( true )
                return
            default:
                return;
        }
    }

    const onChangeRangeValue = ( value: number ) => {
        if ( !video.current ) return
        if ( sync ) {
            const videoCurrentTime = video.current.currentTime
            const timeGap = videoDuration * value / rangeMax - videoCurrentTime
            dispatch( { type: LocalVideoAction.TICK, time: timeGap } )
            return
        }
        video.current.currentTime = videoDuration * value / rangeMax
        setVideoCurrentTime( ( value * videoDuration ) / rangeMax )
    }

    const onClickVideo = () => {
        //videoじゃないwrapper
        const action = videoWrapperRef.current && videoWrapperRef.current.classList.contains( "selected" ) ?
            VideoSelectAction.RELEASE :
            VideoSelectAction.SELECT
        forWebView && videoWrapperRef.current && videoWrapperRef.current.classList.toggle( "selected" )
        if ( forWebView ) {
            file && handleVideoSelectSwitch( action, { file, thumbnail } as WebViewVideoType )
        }
        else {
            file && thumbnail && handleVideoSelectSwitch( action, { file, thumbnail } as VideoType )

        }
    }

    const toggleSync = () => {
        setSync && setSync( !sync )
        dispatch( { type: LocalVideoAction.SET_USUAL_SPEED } )
    }

    const togglePlay = ( startPlaying: boolean ) => {
        if ( sync ) {
            dispatch( {
                type: startPlaying ?
                    LocalVideoAction.PLAY :
                    LocalVideoAction.PAUSE
            } )
            return
        }
        setPlay( startPlaying )
    }

    const toggleSlow = () => {
        if ( sync ) {
            dispatch( {
                type: slow ?
                    LocalVideoAction.SET_USUAL_SPEED :
                    LocalVideoAction.SET_SLOW
            } )
            return
        }
        setPlay( true )
        setSlow( !slow )
    }

    const toggleSound = () => {
        if ( soundOn && video.current ) video.current.muted = true
        else if ( video.current ) video.current.muted = false
        setSoundOn( !soundOn )
    }


    const onFrameButtonPressStart = ( reverse = false ) => {
        if ( frameButtonTouched ) return
        setFrameButtonTouched( true )
        let localFrameButtonPressTime = frameButtonPressTime

        const changeVideoSpeedRate = ( localFrameButtonPressTime: number ) => {
            if ( 1000 <= localFrameButtonPressTime && localFrameButtonPressTime <= 2500 ) {
                if ( sync ) {
                    dispatch( { type: LocalVideoAction.TICK, time: reverse ? -1 / 10 : 1 / 10 } )
                    return
                }
                if ( !video.current ) return
                video.current.currentTime += reverse ?
                    -1 / 10 :
                    1 / 10
            }
            else if ( 2500 < localFrameButtonPressTime ) {
                if ( sync ) {
                    dispatch( {
                        type: LocalVideoAction.TICK, time: reverse ?
                            -3 / 10 :
                            3 / 10
                    } )
                    return
                }
                if ( !video.current ) return
                video.current.currentTime += reverse ? -3 / 10 : 3 / 10
            }
        }


        const interval = setInterval( () => {
            setFrameButtonPressTime( frameButtonPressTime + 100 )
            localFrameButtonPressTime += 100
            changeVideoSpeedRate( localFrameButtonPressTime = localFrameButtonPressTime )
        }, 100 )
        setFrameButtonPressTimeUpdateInterval( interval )
    }

    const onFrameButtonPressEnd = ( reverse = false ) => {
        if ( !frameButtonTouched ) return
        setFrameButtonTouched( false )
        if ( frameButtonPressTime <= 1000 ) {
            if ( sync ) {
                dispatch( { type: LocalVideoAction.TICK, time: reverse ? -1 / 30 : 1 / 30 } )
            }
            else {
                if ( !video.current ) return
                video.current.currentTime += reverse ?
                    -1 / 30 :
                    1 / 30
            }
        }
        frameButtonPressTimeUpdateInterval && clearInterval( frameButtonPressTimeUpdateInterval )
        setFrameButtonPressTimeUpdateInterval( null )
        setFrameButtonPressTime( 0 )
    }

    const fullScreen = () => {
        if ( !video.current ) return
        if ( !!video.current.requestFullscreen ) {
            video.current.requestFullscreen();
            // @ts-expect-error
        } else if ( !!video.current.webkitRequestFullScreen ) {
            // @ts-expect-error
            video.current.webkitRequestFullScreen();
            // @ts-expect-error
        } else if ( !!video.current.webkitEnterFullscreen ) {
            // @ts-expect-error
            video.current.webkitEnterFullscreen();
            // @ts-expect-error
        } else if ( !!video.current.mozRequestFullScreen ) {
            // @ts-expect-error
            video.current.mozRequestFullScreen();
            // @ts-expect-error
        } else if ( !!video.current.msRequestFullscreen ) {
            // @ts-expect-error
            video.current.msRequestFullscreen();
        }
    }

    const setVideo = () => {
        try {
            if ( !video.current ) return
            if ( videoDuration ) return
            video.current.duration && setVideoDuration( video.current.duration )
            setTimeUpdate()
            setOnReachEnd()
            playOrShowFirstFrame()
            webViewDispatch( WebViewVideoAction.VIDEO_LOADED )
        }
        catch ( e ) {
            alert( e )
        }
    }

    const setTimeUpdate = () => {
        video.current && video.current.addEventListener( "timeupdate",
            () => video.current && setVideoCurrentTime( video.current.currentTime ) )
    }

    //comparison
    const setOnReachEnd = () => {
        video.current && video.current.addEventListener( "ended",
            () =>
                currentSync.current ?
                    dispatch( { type: LocalVideoAction.SET_TIME_TO_SYNC_START_TIME_AND_PLAY } ) : //sync中に片方がendに達したら、どちらも開始からスタート                    
                    videoRestart()
        )
    }

    const videoRestart = () => {
        if ( !video.current ) return
        video.current.currentTime = 0
        video.current.play() //なぜか止まるので
        setPlay( true )
    }

    const renderVideoController = () =>
        <div
            className={ Styles.controller }
            style={
                ( index === 0 && sync ) ? { display: "none" } : {}
            }>
            <div className={ `${ Styles.bar_and_time } ${ forComparison ? "" : Styles.bar_and_time_not_comparison }` }>
                <div className={ Styles.time_display }>
                    <span>{ changeMillisec2Minute( videoCurrentTime ) }</span> / <span>{ changeMillisec2Minute( videoDuration ) }</span>
                </div>
                <input
                    ref={ rangeInput }
                    className={ Styles.seek_bar }
                    type="range"
                    step="1"
                    min="0"
                    max={ String( rangeMax ) }
                    value={ String( videoCurrentTime * rangeMax / videoDuration ) }
                    onChange={ ( e ) => onChangeRangeValue( Number( e.target.value ) ) }
                    onTouchStart={ () => {
                        setPlay( false );
                        webViewDispatch( WebViewVideoAction.START_SEEK )
                    } }
                    onTouchEnd={ () => webViewDispatch( WebViewVideoAction.END_SEEK ) }
                    onClick={ () => setPlay( false ) } />
            </div>
            <div className={ Styles.controller_wrapper }>
                <div style={ index === 0 ? { display: "none" } : {} } className={ `${ Styles.video_control_button } ${ sync && Styles.video_syncing } ${ Styles.sync_button }` }
                    onClick={ () => toggleSync() }>
                    <FontAwesomeIcon icon={ faSyncAlt } />
                </div>
                <div className={ `${ Styles.video_control_button } "video_play_button" ${ play && "video_stop" }` }
                    onClick={ () => {
                        play ?
                            togglePlay( false ) :
                            togglePlay( true )
                    } }>
                    <FontAwesomeIcon icon={ play ? faPause : faPlay } />
                </div>
                <div className={ `${ Styles.video_control_button } ""` }
                    onTouchStart={ () => onFrameButtonPressStart( true ) }
                    onMouseDown={ () => onFrameButtonPressStart( true ) }
                    onTouchEnd={ () => onFrameButtonPressEnd( true ) }
                    onMouseUp={ () => onFrameButtonPressEnd( true ) }>
                    <FontAwesomeIcon icon={ faStepBackward } />
                </div>
                <div className={ `${ Styles.video_control_button } "video_frame_forward_button"` }
                    onTouchStart={ () => onFrameButtonPressStart() }
                    onMouseDown={ () => onFrameButtonPressStart() }
                    onTouchEnd={ () => onFrameButtonPressEnd() }
                    onMouseUp={ () => onFrameButtonPressEnd() }>
                    <FontAwesomeIcon icon={ faStepForward } />
                </div>
                <div className={ `${ Styles.video_control_button } ${ Styles.video_control_small_button }` } onClick={ () => toggleSlow() }>
                    { slow ?
                        <FontAwesomeIcon icon={ faPlay } /> :
                        <FontAwesomeIcon icon={ faEject } style={ { transform: "rotate(90deg)" } } /> }
                </div>
                <div className={ `${ Styles.video_control_button } ${ Styles.video_control_small_button } ${ Styles.expand_button }` } onClick={ () => fullScreen() }>
                    <FontAwesomeIcon icon={ faExpand } />
                </div>
                <div className={ `${ Styles.video_control_button } ${ Styles.video_control_small_button } ${ Styles.volume_button }` } onClick={ () => toggleSound() }>
                    <FontAwesomeIcon icon={ soundOn ? faVolumeUp : faVolumeMute } />
                </div>
                <div className={ `${ Styles.video_control_button } ${ Styles.video_control_small_button } ${ Styles.flip_button }` } onClick={ () => setIsFlippedHorizontal( !isFlippedHorizontal ) }>
                    <FontAwesomeIcon icon={ faExchangeAlt } />
                </div>
                <MediaQuery query="(min-width: 900px)">
                    {/* <div className={ `${ Styles.video_control_button } ${ Styles.video_control_small_button } ${ Styles.scale_button }` }>
                        <FontAwesomeIcon icon={ faSearchPlus } onClick={ () => setScale( scale + 0.1 ) } />
                        <FontAwesomeIcon icon={ faSearchMinus } onClick={ () => setScale( scale - 0.1 ) } />
                    </div> */}
                    <div className={ `${ Styles.video_control_button } ${ Styles.video_control_small_button } ${ Styles.scale_button }` } onClick={ () => setScale( scale + 0.1 ) }>
                        <FontAwesomeIcon icon={ faSearchPlus } />
                    </div>
                    <div className={ `${ Styles.video_control_button } ${ Styles.video_control_small_button } ${ Styles.scale_button }` } onClick={ () => 0.2 < scale && setScale( scale - 0.1 ) }>
                        <FontAwesomeIcon icon={ faSearchMinus } />
                    </div>
                </MediaQuery>
                <div className={ `${ Styles.video_control_button } ${ Styles.menu_button }` } onClick={ () => setActionSheetVisible( !actionSheetVisible ) }>
                    <FontAwesomeIcon icon={ faEllipsisV } />
                </div>
            </div>
        </div>

    const videoMoveObjectAndPinchToZoom = useMoveObjectAndPinchToZoom(
        video.current,
        isFlippedHorizontal,
        true,
        () => { },
        forComparison
    )

    const VideoThumbnailMemo = useMemo( () =>
        <VideoThumbnail
            thumbnail={ thumbnail as string }
            file={ file }
            showVideo={ showVideo as () => void } />
        , [ showThumbnailInitially ] )

    const VideoComponentMemo =
        useMemo(
            () => {
                // typeof window !== "undefined" && alert( fileWithParameter )
                const videoWrapperStyle = forComparison ?
                    { transform: `scale(${ scale })` } :
                    { transform: `scale(${ scale })` }
                return (
                    <div style={ videoWrapperStyle }
                        ref={ videoWrapperRef }
                        className={ `${ Styles.video_wrapper } ${ videoIsSelected ? "selected" : "" }` }
                        data-vjs-player>
                        {GridLines }
                        <video
                            src={ fileWithParameter }
                            ref={ video }
                            onClick={ () => onClickVideo() }
                            onError={ e => {
                                if ( 7 <= avoidingCacheCount ) return
                                setTimeout(
                                    () => setAvoidingCacheCount( avoidingCacheCount + 1 )
                                    , 2000 )
                            } }
                            { ...videoMoveObjectAndPinchToZoom }
                            poster={ thumbnail }
                            controls={ false }
                            muted={ true }
                            loop={ false }
                            className={ `${ transparent ? Styles.transparent : "" } ${ forWebView ? Styles.for_webview_video : "" } ${ forComparison ? Styles.for_comparison_video : "" } video-js vjs-default-skin` }
                            onCanPlayThrough={ setVideo }
                            preload="auto"
                            playsInline={ true }
                            // type="application/x-mpegURL"
                            crossOrigin={ ENVIRONMENT === "production" ? "anonymous" : "" }>
                        </video>
                        {!forComparison && 30 < videoViewCount &&
                            <div className={ Styles.video_view_count_wrapper }>
                                <FontAwesomeIcon icon={ faPlay } className={ Styles.video_view_count_icon } />
                                <div className={ Styles.video_view_count }>{ videoViewCount }</div>
                                <div className={ Styles.video_view_count_unit }>回</div>
                            </div> }
                    </div>
                )
            }
            , [ fileWithParameter, scale, videoMoveObjectAndPinchToZoom ] )

    const renderVideoDrawModal = () => {
        const videoScale = video.current ?
            Number( video.current.style.transform.split( ',' ).slice( -1 )[ 0 ].slice( 0, -1 ) ) :
            1
        return video.current && (
            <VideoDrawModal
                video={ video.current }
                videoScale={ videoScale }
                closeModal={ () => setDrawMode( false ) }
                forWebView={ forWebView }
                webViewDispatch={ webViewDispatch } />
        )
    }

    const menuList: ActionSheetMenuType[] = [
        { name: "他の投稿での比較に使用", func: () => handleVideoSelectSwitch( VideoSelectAction.SAVE, { file, thumbnail } as { file: string, thumbnail: string } ) },
        {
            name: "動画をダウンロード", func: () => forWebView ?
                webViewDispatch( WebViewVideoAction.DOWNLOAD_VIDEO ) :
                downloadVideoLinkRef.current && downloadVideoLinkRef.current.click()
        },
    ]

    return (
        showThumbnailInitially ?
            VideoThumbnailMemo :
            <div className={ clsx( Styles.container, forComparison && Styles.for_comparison_container ) }
                style={
                    forComparison ?
                        index === 0 ?
                            { zIndex: 2 } :
                            { zIndex: 1 } :
                        {}
                } //comparison
                onTouchStart={ ( e ) => e.stopPropagation() }>
                <div className={ clsx( Styles.video_icon_wrapper, Styles.draw_icon_wrapper ) } onClick={ () => setDrawMode( true ) }>
                    <BsPencil
                        // icon={ faPencilAlt }
                        className={ Styles.draw_icon } />
                </div>
                {/*<div className={ clsx(
                    Styles.video_icon_wrapper,
                    Styles.show_grid_icon_wrapper,
                    gridLineVisible && Styles.active_grid_icon_wrapper ) }
                    onClick={ gridLineVisible ? hideGridLines : showGridLines }>
                    <BsGrid3X3
                        className={ Styles.grid_icon } />
                </div>*/}
                <div className={ clsx(
                    Styles.video_icon_wrapper,
                    Styles.show_grid_icon_wrapper,
                    stageNum && Styles.active_grid_icon_wrapper ) }
                    onClick={ incrementGridStage }>
                    <BsGrid3X3
                        className={ Styles.grid_icon } />
                </div>
                { drawMode &&
                    renderVideoDrawModal() }
                { VideoComponentMemo }
                { renderVideoController() }
                <ActionSheet
                    menuList={ menuList }
                    visible={ actionSheetVisible }
                    hideActionSheet={ () => setActionSheetVisible( false ) } />
                <a
                    style={ { display: "none" } }
                    href={ fileMp4 }
                    ref={ downloadVideoLinkRef }
                    download={ fileMp4 }>
                </a>
            </div >
    )
}

type VideoThumbnailProps = {
    thumbnail: string,
    file: string,
    showVideo: () => void
}

const VideoThumbnail: FC<VideoThumbnailProps> = ( {
    thumbnail,
    file,
    showVideo
} ) => {

    const [ videoDuration, setVideoDuration ] = useState<string>( "" );

    return (
        <div className={ Styles.thumbnail_container }>
            <div className={ Styles.thumbnail_wrapper }
                onClick={ () => showVideo() } >
                <img
                    className={ Styles.thumbnail }
                    src={ thumbnail } />
                <video
                    src={ file }
                    preload="metadata"
                    onLoadedMetadata={ ( e ) =>
                        setVideoDuration(
                            changeMillisec2Minute( ( e.target as HTMLVideoElement ).duration ) )
                    }
                    style={ { display: "none" } }
                />
                <div className={ Styles.video_thumbnail_duration }>
                    { videoDuration }
                </div>
                <FontAwesomeIcon
                    className={ Styles.video_play_button_on_thumbnail }
                    icon={ faPlayCircle as IconProp } />
            </div>
        </div> )
}

export default Video
